import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import ReservedPostException from "@/exceptions/postExceptions/ReservedPostException";
import { ValidationException } from "@/common/exceptions/ValidationException";
import InternalServerError500Exception from "@/exceptions/InternalServerError500Exception";
export function api__getOrderWithPaymentInfo(_x, _x2, _x3) {
  return _api__getOrderWithPaymentInfo.apply(this, arguments);
}
function _api__getOrderWithPaymentInfo() {
  _api__getOrderWithPaymentInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(user_id, orderId, post_id) {
    var _res$data10, _res$data11, _res$data11$data, _res$data12, _res$data13, _data$customer, _data$customer2;
    var includes, res, data;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          includes = ['roadService', 'warranty', 'banks'];
          if (orderId) {
            includes.push('payment_info');
          }
          if (!(!orderId && !post_id)) {
            _context5.next = 4;
            break;
          }
          throw new Error("orderId or post_id is required");
        case 4:
          _context5.next = 6;
          return fetcher().post("/order/get-details?include=".concat(includes.join(',')), {
            orderid: orderId,
            post_id: post_id,
            is_online: 1
          });
        case 6:
          res = _context5.sent;
          if (!(!(res !== null && res !== void 0 && (_res$data10 = res.data) !== null && _res$data10 !== void 0 && _res$data10.success) || !(res !== null && res !== void 0 && (_res$data11 = res.data) !== null && _res$data11 !== void 0 && (_res$data11$data = _res$data11.data) !== null && _res$data11$data !== void 0 && _res$data11$data.post_id) || Array.isArray(res === null || res === void 0 ? void 0 : (_res$data12 = res.data) === null || _res$data12 === void 0 ? void 0 : _res$data12.data))) {
            _context5.next = 9;
            break;
          }
          throw new Error("Failed to get order details, orderId: ".concat(orderId, ", post_id: ").concat(post_id));
        case 9:
          data = (res === null || res === void 0 ? void 0 : (_res$data13 = res.data) === null || _res$data13 === void 0 ? void 0 : _res$data13.data) || {};
          if (!(data.post_url && data !== null && data !== void 0 && (_data$customer = data.customer) !== null && _data$customer !== void 0 && _data$customer.id && user_id && Number(data === null || data === void 0 ? void 0 : (_data$customer2 = data.customer) === null || _data$customer2 === void 0 ? void 0 : _data$customer2.id) != Number(user_id) && (data.reserved_status && data.reserved_status != 1 || post_id && data.post_id && data.post_id != post_id || data.is_deleted))) {
            _context5.next = 12;
            break;
          }
          throw new ReservedPostException(data.post_id);
        case 12:
          data.city_id = Number(data.city_id);
          return _context5.abrupt("return", data);
        case 14:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _api__getOrderWithPaymentInfo.apply(this, arguments);
}
export var api__createOrder = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(formData) {
    var _res$data, _res$data2, _res$data3;
    var res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetcher().post("/order/create", formData);
        case 2:
          res = _context.sent;
          if (!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.success)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", res.data.data);
        case 5:
          if (!((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code) === 230 || (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.code) === 422)) {
            _context.next = 7;
            break;
          }
          throw ValidationException.factoryFromAxios(res);
        case 7:
          throw InternalServerError500Exception.factoryFromAxios(res);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__createOrder(_x4) {
    return _ref.apply(this, arguments);
  };
}();
export var api__createOrderOutSideWorkingOur = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(post_id, formData) {
    var updatedFormData, _res$data4, res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          // Create a new object to avoid mutating the original formData
          updatedFormData = _objectSpread(_objectSpread({}, formData), {}, {
            is_online: 1,
            reserve_car_by_phone: 1,
            post_id: post_id
          });
          _context2.prev = 1;
          _context2.next = 4;
          return fetcher().post("/order/create", updatedFormData);
        case 4:
          res = _context2.sent;
          if (!(res !== null && res !== void 0 && (_res$data4 = res.data) !== null && _res$data4 !== void 0 && _res$data4.success)) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return", res.data.data);
        case 7:
          throw new InternalServerError500Exception("Failed to create offline order 'api__createOrderOutSideWorkingOur' ");
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](1);
          throw ValidationException.factoryFromAxios(_context2.t0);
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 10]]);
  }));
  return function api__createOrderOutSideWorkingOur(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__getOrderDetailsByParams = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(formData) {
    var _res$data5, _res$data6, _res$data6$data, _res$data7, _res$data8;
    var includes, res, data;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          includes = ['roadService', 'warranty', 'banks'];
          _context3.next = 3;
          return fetcher().post("/order/get-details?include=".concat(includes.join(',')), _objectSpread(_objectSpread({}, formData), {}, {
            is_online: 1
          }));
        case 3:
          res = _context3.sent;
          if (!(!(res !== null && res !== void 0 && (_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.success) || !(res !== null && res !== void 0 && (_res$data6 = res.data) !== null && _res$data6 !== void 0 && (_res$data6$data = _res$data6.data) !== null && _res$data6$data !== void 0 && _res$data6$data.post_id) || Array.isArray(res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.data))) {
            _context3.next = 6;
            break;
          }
          throw new Error("Failed to get order details");
        case 6:
          data = (res === null || res === void 0 ? void 0 : (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.data) || {};
          data.city_id = Number(data.city_id);
          return _context3.abrupt("return", data);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function api__getOrderDetailsByParams(_x7) {
    return _ref3.apply(this, arguments);
  };
}();
export var api__getPromoCode = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref4) {
    var _res$data9;
    var code, post_id, city_id, res;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          code = _ref4.code, post_id = _ref4.post_id, city_id = _ref4.city_id;
          _context4.next = 3;
          return fetcher().post("/order/referral-code-check", {
            code: code,
            post_id: post_id,
            city_id: city_id
          });
        case 3:
          res = _context4.sent;
          if (res !== null && res !== void 0 && (_res$data9 = res.data) !== null && _res$data9 !== void 0 && _res$data9.success) {
            _context4.next = 6;
            break;
          }
          throw new Error("Failed to get promo code");
        case 6:
          return _context4.abrupt("return", res.data.data);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function api__getPromoCode(_x8) {
    return _ref5.apply(this, arguments);
  };
}();